import { Route } from '@angular/router';

export const localTournamentGamesRoutes: Route[] = [
    {
        path: 'local-tournament-game/match',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./match/pages/match-local-tournament-game/match-local-tournament-game.component').then(
                (c) => c.MatchLocalTournamentGameComponent
            ),
    },
];
